import React, { useState } from "react";
import styled from "styled-components";

const EditButton = styled.button`
  background: transparent;
  display: inline-block;
  color: blue;
  padding: 0;
  margin: 0;
  font-size: 12px;
  font-weight: normal;
  box-shadow: none;
  border: none;
`;

type EditorProps<T> = {
  onFinish: (nextValue: T) => void;
};

type EditComponentProps<T> = React.HTMLProps<HTMLDivElement> & {
  editor: (params: EditorProps<T>) => JSX.Element;
  enableEdit?: boolean;
};

const EditComponent = ({
  editor,
  children,
  enableEdit = false,
}: EditComponentProps<string>): JSX.Element => {
  const [isEditing, setIsEditing] = useState(false);

  if (isEditing) {
    return editor({ onFinish: () => setIsEditing(false) });
  }

  return (
    <span>
      {children}{" "}
      {enableEdit && (
        <EditButton onClick={() => setIsEditing(true)}>EDIT</EditButton>
      )}
    </span>
  );
};

export default EditComponent;
